/* eslint-disable no-undef */

export type TooltipProps = {
  text: string;
  children: JSX.Element;
  _className?: string;
  disabled?: boolean;
  className?: string;
  position?: "top" | "bottom" | "left" | "right";
  maxWidth?: string;
};

function NewTooltip(props: TooltipProps) {
  const {
    text,
    children,
    _className,
    className,
    disabled = false,
    position = "bottom",
    maxWidth = "500px",
  } = props;

  const positionClasses = {
    top: "bottom-full mb-2",
    bottom: "top-full mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
  };

  const arrowClasses = {
    top: "top-full left-1/2 -translate-x-1/2 -mt-1 rotate-45",
    bottom: "bottom-full left-1/2 -translate-x-1/2 -mb-1 rotate-45",
    left: "left-full top-1/2 -translate-y-1/2 -ml-1 rotate-45",
    right: "right-full top-1/2 -translate-y-1/2 -mr-1 rotate-45",
  };

  const needsCentering = position === "top" || position === "bottom";

  return (
    <div className="relative group">
      {children}
      <div
        className={`absolute flex-col items-center hidden z-[9999] ${
          positionClasses[position]
        } ${disabled ? "" : "group-hover:flex"} ${className}`}
        style={{
          maxWidth,
          width: maxWidth,
          ...(needsCentering && {
            left: "50%",
            transform: "translateX(-50%)",
          }),
        }}
      >
        <div
          className={`relative z-[10000] p-2 text-sm text-black shadow-lg bg-[#f6f9fb] rounded-md w-full ${_className}`}
        >
          {text}
        </div>
        <div
          className={`w-3 h-3 bg-[#f6f9fb] z-[9999] ${arrowClasses[position]}`}
        ></div>
      </div>
    </div>
  );
}

export default NewTooltip;
